// extracted by mini-css-extract-plugin
export default {"gameArea":"suikaGame_gameArea__2TmMa","gameWrap":"suikaGame_gameWrap__mBnp3","canvasArea":"suikaGame_canvasArea__-aAos","canvasWrap":"suikaGame_canvasWrap__424+P"};